// 菜单
export default {
  'menu.login': '登陆',
  'menu.home': '首页',
  'menu.workplace': '工作台',
  'menu.setting': '个人设置',
  'menu.logout': '退出',
  'menu.setting.basic': '基本信息',
  'menu.setting.security': '安全设置',
  'menu.system': '系统设置',
  'menu.system.admin-list': '管理员列表',
  'menu.system.role-list': '角色列表',
  'menu.system.func-list': '功能列表',
  'menu.system.error-log-list': '错误日志',
  'menu.system.product-list': '商品列表',
  'menu.system.cache-manage': '缓存管理',
  'menu.member': '用户管理',
  'menu.member.user-list': '用户列表',
  'menu.member.user-account-list': '账户流水',
  'menu.member.user-recharge-list': '上分记录',
  'menu.member.user-cashout-list': '下分列表',
  'menu.agent': '代理管理',
  'menu.agent.list': '代理列表',
  'menu.agent.account-list': '账户流水',
  'menu.agent.recharge-list': '充值记录',
  'menu.op': '运营支撑',
  'menu.op.bet-list': '下注记录',
  'menu.op.lotto-list': '开奖数据',
  'menu.op.lotto-bet-setting': '赔率设置',
}